import styled, { css } from 'react-emotion';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const PinnedPost = styled.div`
  cursor: pointer;
  max-height: 240px;
  padding: ${theme.spacing.small} ${theme.spacing.small} 0;
  overflow: hidden;

  &:hover .fade {
    background: linear-gradient(
      rgba(255, 255, 255, 0),
      rgb(255 255 255 / 16%),
      rgb(247 247 247)
    );
  }

  &:hover {
    background: ${colors.blackAlpha(0.04)};
  }
`;

export const UserBanner = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-shrink: 2;
`;
export const UserImage = styled.div`
  flex-shrink: 0;
`;
export const UserNameWrapper = styled.div`
  margin-left: 8px;
  height: 100%;
  flex-wrap: 'nowrap';
  flex-shrink: 2;
`;

export const UserName = styled.span`
  color: ${colors.designSystem.blackOpacity87};
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.small};
  font-weight: ${theme.font.weight.semiBold};
  line-height: 14px;
`;

export const Time = styled.div`
  color: ${colors.blackAlpha(0.6)};
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.small};
`;

export const PostContentContainer = styled.div`
  color: ${colors.black};
  font-family: ${theme.font.family.workSans};
  font-style: normal;
  font-weight: normal;
  font-size: ${theme.font.size.small};
  line-height: 16px;
  max-height: 136px;
  overflow: hidden;
  padding-top: ${theme.spacing.xxSmall};
  position: relative;
  word-wrap: break-word;
  width: 100%;

  .post-content {
    display: block;
  }

  .post-content.empty {
    padding: 5px;
  }

  > .fade {
    background: linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 1)
    );

    bottom: 0;
    left: 0;
    padding: ${theme.spacing.large};
    position: absolute;
    width: 90%;
  }
`;

export const Footer = styled.div`
  border-bottom: 1px solid ${colors.blackAlpha(0.12)};
  display: flex;
  justify-content: space-between;
  padding: ${theme.spacing.small} 0;
  min-height: 18px;

  div {
    display: flex;
  }
`;

export const Label = styled.span`
  color: ${colors.blackAlpha(0.6)};
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.copy};
  line-height: 14px;
`;

export const IconWrapper = styled.div`
  display: flex;
  margin-right: ${theme.spacing.small};

  span.count {
    color: ${colors.blackAlpha(0.6)};
    font-family: ${theme.font.family.workSans};
    font-size: ${theme.font.size.small};
    line-height: 16px;
    margin-left: 5px;
  }
`;

export const IconStyle = {
  height: 16,
  width: 16,
  color: colors.blackAlpha(0.6),
  fill: colors.blackAlpha(0.6),
};

export const VisuallyHidden = css`
  :not(:focus):not(:active) {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;
